import React, { PropsWithChildren } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
//import { makeStyles, Theme, createStyles, withStyles } from '@material-ui/core/styles';
import { Theme, withStyles } from '@material-ui/core/styles';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Tooltip from '@material-ui/core/Tooltip';
import { ButtonGroup } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { Participant } from 'twilio-video';
import useSendMessage from '../../../hooks/useSendMessage/useSendMessage';
import { useAppState } from "../../../state";
import { MESSAGE_TYPES } from '../../../constants';

interface PinMenuProps {
    participant: Participant;
}

const HtmlTooltip = withStyles((theme: Theme) => ({
    tooltip: {
        backgroundColor: '#000000',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 120,
        fontSize: theme.typography.pxToRem(12)
    },
}))(Tooltip);

export default function PinIcon({ participant }: PropsWithChildren<PinMenuProps>) {
    const [sendMessage] = useSendMessage();
    const { initRemoteAction } = useAppState();


    const handleClick = (messageType:string) => {
        if (participant) {
            var sid = participant.sid;
            //console.log('Sending message ' + messageType + ' to '+ sid);
            sendMessage(messageType, sid);

            initRemoteAction(messageType, participant.identity, sid).then((response) => {
                var t = JSON.parse(response);
                /*if (t.msg === "") {
                    console.log("Success: " + sid);
                } else {
                    console.log("Failed: " + sid);
                }*/
            });
        }

    };

    /*<Typography color="inherit">Mute</Typography>
                <b>{'Unmute'}</b>*/
    //const classes = useStyles();
    return (
        <HtmlTooltip title={
            <React.Fragment>
                <ButtonGroup disableElevation variant="contained" size="small" aria-label="small outlined button group" orientation="vertical">
                    <Button onClick={() => { handleClick(MESSAGE_TYPES.EJECT) }}>Eject</Button>
                    if(isTrackEnabled) {
                        <Button onClick={() => { handleClick(MESSAGE_TYPES.UNMUTE) }}>Unmute</Button>
                    } else {
                        <Button onClick={() => { handleClick(MESSAGE_TYPES.MUTE) }}>Mute</Button>
                    }
                    <Button onClick={() => { handleClick(MESSAGE_TYPES.PROMOTE_USER) }}>Promote</Button>
                </ButtonGroup>
            </React.Fragment>
        } aria-label="menu" interactive>
            <SvgIcon style={{ float: 'right', fontSize: '29px' }}>
                <MoreVertIcon />
            </SvgIcon>
        </HtmlTooltip>
    );
}
